import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { Link } from "react-router-dom";
import { useState } from "react";
import AgeGateDialog from "@/components/AgeGateDialog";
import TierPickerDialog from "@/components/TierPickerDialog";

export default function MemberCTA({ label = "Membership required" }) {
  const { user } = useAuth();
  const [ageOpen, setAgeOpen] = useState(false);
  const [tierOpen, setTierOpen] = useState(false);

  const launchCheckout = async (tier = "base") => {
    const { data } = await api.post("/payments/checkout", { origin_url: window.location.origin, tier });
    window.location.href = data.checkout_url;
  };

  const subscribe = () => {
    if (!user) return;
    if (!user.age_verified) {
      setAgeOpen(true);
      return;
    }
    setTierOpen(true);
  };

  return (
    <div className="telesis-panel rounded p-5 border-l-2 border-yellow-400/60">
      <AgeGateDialog
        open={ageOpen}
        onOpenChange={setAgeOpen}
        onVerified={() => setTierOpen(true)}
      />
      <TierPickerDialog
        open={tierOpen}
        onOpenChange={setTierOpen}
        onPicked={async (tier) => {
          try {
            await launchCheckout(tier);
          } catch (e) {
            const detail = e?.response?.data?.detail;
            if (detail === "age_verification_required") {
              setTierOpen(false);
              setAgeOpen(true);
              return;
            }
            toast.error(detail || "Checkout failed");
            throw e;
          }
        }}
      />
      <p className="telesis-eyebrow">Members only</p>
      <p className="text-sm text-slate-200 mt-2">{label}.</p>
      <div className="mt-3">
        {user ? (
          <Button
            data-testid="member-cta-subscribe"
            onClick={subscribe}
            className="rounded-full bg-yellow-400 text-black hover:bg-yellow-300 font-semibold"
          >
            Join · from 20.21 CAD / month
          </Button>
        ) : (
          <Link to="/login" className="text-yellow-400 underline">Sign in to continue</Link>
        )}
      </div>
    </div>
  );
}
